<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            <span> {{ row.index + 1 }} </span>
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Modifica prestazione" variant="outline-success" @click="onClickPrestazioneEdit(item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Cancella Prestazione" variant="outline-danger" @click="onDeletePrestazione(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <rsa-configurazione-prestazioni-ambulatoriali-edit-component ref="cmpRsaConfigurazionePrestazioniAmbulatorialiEdit" @savePrestazione="onSavePrestazione" @onClose="loadData" @deletePrestazione="onDelete"> </rsa-configurazione-prestazioni-ambulatoriali-edit-component>
            <b-row class="sa-label-info">
                <b-col lg="3">
                    <p>Record Totali: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazionePrestazioniAmbulatorialiEditComponent from "./RsaConfigurazionePrestazioniAmbulatorialiEditComponent.vue";
export default {
    components: { RsaConfigurazionePrestazioniAmbulatorialiEditComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsaprestazioniambulatoriali",
            showModalLoading: false,
            listKey: 0,
            items: [],
            filtroPrestazioniAmbulatoriali: { codicePrestazione: null, codiceOffering: null, descrizione: null },
            btnNuovaPrestazioneHidden: false,
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Codice Prestazione",
                    key: "codicePrestazione",
                    sortable: true,
                },
                {
                    label: "Codice Offering",
                    key: "codiceOffering",
                },
                {
                    label: "Tipo",
                    key: "tipo",
                },
                {
                    label: "Descrizione",
                    key: "descrizione",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroPrestazioniAmbulatoriali"]) {
                me.filtroPrestazioniAmbulatoriali = JSON.parse(sessionStorage["filtroPrestazioniAmbulatoriali"]);
                me.$emit("updateFilter", me.filtroPrestazioniAmbulatoriali);
            }
            me.filtroPrestazioniAmbulatoriali.page = me.currentPage;
            me.filtroPrestazioniAmbulatoriali.forPage = me.perPage;

            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroPrestazioniAmbulatoriali, me.loadDataSuccess, me.loadDataError);
            this.showModalLoading = true;
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            console.error("Errore durante il caricamento dei dati:", error);
            me.items = [];
            me.rows = 0;
            let me = this;
            me.$emit("afterLoadData");
        },
        onClickPrestazioneEdit(item) {
            let me = this;
            me.$refs.cmpRsaConfigurazionePrestazioniAmbulatorialiEdit.show(item);
        },
        nuovaPrestazioneAmbulatoriale() {
            let me = this;
            me.$refs.cmpRsaConfigurazionePrestazioniAmbulatorialiEdit.show({
                id: null,
                codicePrestazione: null,
                codiceOffering: null,
                tipo: null,
                descrizione: null,
            });
        },
        onSavePrestazione() {
            let me = this;
            me.loadData();
        },
        onDeletePrestazione(item) {
            let me = this;
            me.$refs.cmpRsaConfigurazionePrestazioniAmbulatorialiEdit.onDeletePrestazione(item);
        },
        onDelete() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
